var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8842 28L15.093 23.73L19.3017 28L21.1302 26.145L16.9214 21.875L21.1302 17.605L19.3017 15.75L15.093 20.02L10.8842 15.75L9.05578 17.605L13.2646 21.875L9.05578 26.145L10.8842 28ZM27.5986 3.5H25.8737V0H22.4238V3.5H8.62455V0H5.17473V3.5H3.44982C1.53517 3.5 0.0172491 5.075 0.0172491 7L0 31.5C0 33.425 1.53517 35 3.44982 35H27.5986C29.496 35 31.0484 33.425 31.0484 31.5V7C31.0484 5.075 29.496 3.5 27.5986 3.5ZM27.5986 31.5H3.44982V12.25H27.5986V31.5Z",
    fill: "#C6C6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGray);
export default __webpack_public_path__ + "static/media/calendarGray.f6c36c91b4908b1203c6f98747720a24.svg";
export { ForwardRef as ReactComponent };